import React from 'react';
import { PROFILE_HEADER_BANNER } from 'Constants';

function TopBanner() {
  return <div id='profile-header-banner'>{PROFILE_HEADER_BANNER}</div>;
}

export default TopBanner;
